import React from 'react';
import { FormattedMessage } from 'react-intl';

import type { DocListResponse } from '../../openapi/types';

import { useCanManageDocInternalInfo } from './DocInternalInfo';
import { docListMessages } from './docsMessages';

export const ResponsiblePersonHeader: React.FC = () =>
  useCanManageDocInternalInfo() ? (
    <th>
      <FormattedMessage {...docListMessages.docListColumnResponsiblePerson} />
    </th>
  ) : null;

export const ResponsiblePersonCell: React.FC<Pick<DocListResponse, 'responsible_person'>> = ({
  responsible_person,
}) =>
  useCanManageDocInternalInfo() ? (
    <td>{`${responsible_person?.name ?? ''} ${responsible_person?.surname ?? ''}`.trim()}</td>
  ) : null;
